import React from 'react';
import { PageMeta } from '../../components/PageMeta';
import { ModaNetwork } from '../../components/ModaNetwork';

export const ModaNetworkPage: React.FC = () => (
  <>
    <PageMeta
      title="Moda Network"
      description="Experience best-in-class personal shopping services with Moda Network."
    />
    <ModaNetwork />
  </>
);
